import { makeAutoObservable, runInAction } from "mobx";
import { callRemoteMethod } from "../utils/WebserviceHandler";
import CONSTANTS from "../utils/constants"


import { ErrorWrapper } from "../utils/ErrorWrapper"
import { date } from "yup";
import { NotifyError } from "../utils/ShowError";
import General from '../stores/GeneralStore'
import userStore from "./UserStore";

interface Bill {
  id: number;
  accountNumber: String | null;
  paymentDate: String | null;
  paymentReference: String | null;
  premiseDetails: String | null;
  customerName: String | undefined;
  paymentStatus: String | null;
}

interface Payment {
  id: number;
  accountNumber: String | null;
  paymentDate: String | null;
  paymentReference: String | null;
  premiseDetails: String | null;
  customerName: String | undefined;
  paidAmount: String | null;
}

interface PostDatedCheque {
  id: number;
  accountNumber: String | null;
  sewerageNumber: String | null;
  premiseDetails: String | null;
  createdDate: String | null;
  chqDate: String | null;
  chqNumber: String | null;
  bankNameAccount: String | undefined;
  chqAmount: String | null;
  status: String | null;
}

interface BillData {
  [key: string]: string | undefined;
}

interface Obj {
  [key: string]: any;
}
function downloadPDF(pdf: string) {
  const linkSource = `data:application/pdf;base64,${pdf}`;
  const downloadLink = document.createElement("a");
  const fileName = "abc.pdf";
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}
class SocialCaseRequest {
  bills: Bill[] = [];
  socialCase: Obj = {}

  constructor() {
    makeAutoObservable(this);
  }

  submitSocialCaseDetails = ErrorWrapper(async (
    data: {
      customerName: string,
      customerAccount: string | null,
      emiratesId: string,
      tariffType: string,
      dueAmount: number,
      applicationDate: string,
      familyMember: number,
      socialStatus: string,
      justification: string | null,
      requestNo: string | null,
      status: string | null,
      //"comments": caseDetailsComments,
      platform: "web",
      applicationDateStr: string,
      parcelNumber: string,
      personNumber: string,
      caseNo: string | null
    }
  ) => {
    return await callRemoteMethod({ endpoint: CONSTANTS.URL.CASE_DETAILS_SUBMIT, type: 'POST', data });


  })
  supdateSocialCaseDetails = ErrorWrapper(async (
    data: {
      customerName: string,
      commentReply: any,
      customerAccount: string | null,
      emiratesId: string,
      tariffType: string,
      dueAmount: number,
      applicationDate: string,
      familyMember: number,
      socialStatus: string,
      justification: string | null,
      requestNo: string | null,
      status: string | null,
      platform: "web",
      applicationDateStr: string,
      parcelNumber: string,
      personNumber: string,
      caseNo: string | null,
      comments: string | null,
      files: Obj[] | undefined;

    }
  ) => {
    console.log(data)
    return await callRemoteMethod({ endpoint: CONSTANTS.URL.CASE_DETAILS_UPDATE, type: 'POST', data });


  })

  uploadSocialCaseDocuments = ErrorWrapper(async (data: any) => {
   const res= await callRemoteMethod({ endpoint: CONSTANTS.URL.CASE_DETAILS_DOCUMENTS_UPLOAD, type: 'POST', data, file: true });
return res;


  })

  pushToSocialCase = (data: { caseDetailsComments: String, familyMember: number, socialStatus: string }) => {
    this.socialCase = {
      ...this.socialCase,
      ...data
    }
  }

  getParcelDetails = ErrorWrapper(async ({ parcelId, personId }: { parcelId: string, personId: string }) => {
    const data = {
      parcelId,
      personId
    }
    const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.VERIFY_SOCIAL_CASE, type: 'GET', data });


    runInAction(() => {
      this.socialCase = res.result

    })
  })
  // downloadSocialCase = ErrorWrapper(async (data:any) => {
  //   const  {fileName,caseNo}=data;
  //   const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.DOWNLOAD_SOCIAL_CASE(fileName,caseNo), type: 'GET', data });


  //   runInAction(() => {
  //     this.socialCase = res.result

  //   })
  // })
  downloadSocialCase = ErrorWrapper(async (data:any) => {
    const  {fileName,caseNo}=data;
    // try{
    //   const res = await callRemoteMethod({ endpoint: CONSTANTS.URL.DOWNLOAD_SOCIAL_CASE(fileName,caseNo), file: true });
    //   downloadPDF(res)
    // }catch(error){
    //   NotifyError(General?.codeLabels['cm_no_bill_available']?.label)
    // }
    let { info } = await userStore;
    try {
      const headers = new Headers();
      if (info.token) {
        headers.append("Authorization", `Bearer ${info.token}`);
      }
  
      const response = await fetch(CONSTANTS.URL.DOWNLOAD_SOCIAL_CASE(fileName,caseNo), {
        method: "GET",
        headers: headers,
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const blob = await response.blob();
  
      // Create a URL for the blob data
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an invisible link to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName || "downloaded-file";
      a.style.display = "none";
      document.body.appendChild(a);
  
      // Trigger the click event on the link
      a.click();
  
      // Remove the link element
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading the file: ", error);
    }
    
  })
  
}

const socialCaseRequestStore = new SocialCaseRequest()
export default socialCaseRequestStore;
